import * as React from "react";
import useSWR from "swr";
import fetcher from "./fetcher";

const baseEndpoint = "/api/franchise";

export default function useFranchises(query = "") {
  const url = React.useMemo(() => {
    if (query === null) {
      return null;
    }
    const searchParams = new URLSearchParams();
    if (query) {
      searchParams.set("q", query);
    }
    const qs = searchParams.toString();
    return `${baseEndpoint}/admin/list${qs ? `?${qs}` : ""}`;
  }, [query]);

  const { data, error, mutate } = useSWR(url, fetcher, {
    keepPreviousData: true,
  });

  const franchises = React.useMemo(() => {
    if (!Array.isArray(data?.franchises)) {
      return [];
    }
    return data.franchises;
  }, [data]);

  return {
    franchises,
    isLoading: !data && !error,
    isError: Boolean(error),
    error,
    refresh: mutate,
  };
}
